import type { Config } from '../../config/types';
import { ConsoleLogger } from '../components/ConsoleLogger';
import { HttpLogger } from '../components/HttpLogger';
import { SilentLogger } from '../components/SilentLogger';
import type { LogContext } from '../types';

export const createLogger = (config: Config) => {
  const context: LogContext = {
    context: {
      app: config.app,
    },
    ddsource: 'typescript',
    env: config.app.cluster,
    host: config.host,
    network_id: config.network?.id,
    organization: {
      id: config.network?.id,
      name: config.network?.identifier,
    },
    service: config.service,
    source: config.source,
    version: config.version,
  };

  if (config.thirdParty?.datadog !== undefined) {
    if (config.app.env !== 'production') {
      const {
        datadog: { handler, ...baseConfig },
      } = config.thirdParty;

      // Force Handler to avoid send log to datadog
      return new HttpLogger(
        {
          ...baseConfig,
          handler: { ...handler, type: 'console' },
        },
        context,
      );
    }

    return new HttpLogger(config.thirdParty?.datadog, context);
  }

  if (config.app.env === 'development') {
    return new ConsoleLogger(context);
  }

  return new SilentLogger();
};
